import { all, takeLatest, fork, call } from 'redux-saga/effects';
import * as services from './wrike.saga-services';
import * as types from './wrike.types';
import * as constants from './wrike.constants';

function* invokeIntegrateWrike(action: types.IIntegrateWrike) {
  yield call(services.integrateWrike, action.payload.code, action.payload.state);
}

function* invokeFetchWrikeFolders(action: types.IFetchWrikeFolders) {
  yield call(services.fetchWrikeFolders, action.payload);
}

function* invokeSyncWrikeFolders(action: types.ISyncWrikeFolders) {
  yield call(services.syncWrikeFolders, action.payload);
}

function* invokeRemoveWrikeIntegration() {
  yield call(services.removeWrikeIntegration);
}

function* watchWrikeSaga() {
  yield takeLatest(constants.INTEGRATE_WRIKE, invokeIntegrateWrike);
  yield takeLatest(constants.FETCH_WRIKE_FOLDERS, invokeFetchWrikeFolders);
  yield takeLatest(constants.SYNC_WRIKE_FOLDERS, invokeSyncWrikeFolders);
  yield takeLatest(constants.REMOVE_WRIKE_INTEGRATION, invokeRemoveWrikeIntegration);
}

export function* watchWrikePageSaga() {
  yield all([watchWrikeSaga].map(fork));
}
